<template>
  <component :is="page" :product="product" :productToBuy="productToBuy" />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FactPerson from '../components/PurchaseFactPerson';
import MyMonitoring from '../components/PurchaseMonitoring';
import MyPaymentDefaults from '../components/PurchaseMyPaymentDefaults';

export default {
  inheritAttrs: false,
  components: {
    FactPerson,
    MyMonitoring,
    MyPaymentDefaults,
    ShareMyPaymentDefaults: MyPaymentDefaults,
    MyFactReport: FactPerson,
    MyCompanies: FactPerson,
    CompaniesOnPerson: FactPerson,
    PaymentDefaults: FactPerson,
  },
  data: () => ({
    product: null,
  }),
  computed: {
    ...mapState('purchase', ['productToBuy']),
    page() {
      return this.productToBuy.id;
    },
  },
  methods: {
    ...mapActions('product', ['getProductById']),
    ...mapActions('alerts', ['notify']),

    loadProduct() {
      return this.getProductById(this.productToBuy.id)
        .then((product) => this.product = product);
    },
  },
  created() {
    if (this.productToBuy) {
      this.loadProduct();
    } else {
      this.$router.back();
    }

    if (this.$route.query.fail) {
      this.notify({ type: 'danger', text: this.$t('purchase.failed') });
      this.$router.replace({ path: this.$route.path });
    }
  },
  metaInfo() {
    return {
      title: this.$t('purchase.meta.title'),
      meta: [
        { vmid: 'keywords', name: 'keywords', content: this.$t('purchase.meta.keywords') },
        { vmid: 'description', name: 'description', content: this.$t('purchase.meta.description') },
      ],
    };
  },
};
</script>
